import React, { useEffect } from 'react'
import Holder from 'holderjs'
import { Card } from 'react-bootstrap'

export const DocumentImage = ({ src }) => {
  useEffect(() => {
    requestAnimationFrame(function () {
      Holder.run({
        images: '.proj-card-img'
      });
    });
  }, [])

  return (
    <Card.Img
      className="proj-card-img"
      variant="top"
      src={src ? src : "holder.js/100px160?random=yes&text=imagen"}
    />
  )
}